import React from "react";
import './App.css';

import LiberalLaw from "./static/LiberalLaw.png";
import FascistLaw from "./static/FascistLaw.png";

class DecisionModal extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selections: []
    }
  }

  handleSelection(index) {
    var selections = this.state.selections;
    if (this.state.selections.includes(index)) {
    } else if (selections.length < this.props.numChoices) {
      selections.push(index);
    } else {
      selections.shift();
      selections.push(index);
    }
    this.setState({selections : selections})
  }

  render() {
    return (
      <div className="center modal">
        <div className="headerText" style={{ fontSize: 60, textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: this.props.prompt }} />
        <div style={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap', maxWidth: 1000, justifyContent: 'center' }}>
          { this.props.choiceType === "people" && this.props.choices.map((player, index) => {
            return(
              <div 
                key={`player_${index}`}
                onClick={() => { this.handleSelection(index) }}
                className="center headerText clickable" 
                style={{ textAlign: 'center', width: 150, height: 150, margin: 20, borderRadius: 150, backgroundColor: 'black', color: this.state.selections.includes(index) ? 'white' : 'gray', fontSize: 25, transform: this.state.selections.includes(index) ? "scale(1.1)" : "scale(1)", opacity: this.state.selections.includes(index) ? 1 : 0.8  }}>
                { player.name }
              </div>
            )
          })}

          { this.props.choiceType === "laws" && this.props.choices.map((choice, index) => {
              var src;
              if (choice === "LIBERAL") src = LiberalLaw;
              if (choice === "FASCIST") src = FascistLaw;
              return(
                <img 
                  className="clickableCard"
                  src={src} style={{ textAlign: 'center', objectFit: 'contain', height: 200, borderRadius: 3, margin:20,  transform: this.state.selections.includes(index) ? "scale(1.1)" : "scale(1)", opacity: this.state.selections.includes(index) ? 1 : 0.8 }} 
                  onClick={() => { this.handleSelection(index) }}
                />
              );
          })}

        </div>
        <div 
          onClick={() => { if (this.state.selections.length === this.props.numChoices) { this.props.onSubmit(this.state.selections); }}}
          className="center headerText clickable" 
          style={{ fontSize: 40, opacity: this.state.selections.length === this.props.numChoices ? 1 : 0, cursor: this.state.selections.length === this.props.numChoices ? 'pointer' : 'default' }}
        >
           {this.props.submitLabel || "SUBMIT"}
        </div>
      </div>
    );
  }
}


export default DecisionModal
